import { makeStyles, tokens } from '@fluentui/react-components';
import { createContext, useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { vt } from '../theme';

/** The element beside the main pane that a page's inspector renders into (set by Layout). */
export const PageAsideHost = createContext<HTMLElement | null>(null);

const useStyles = makeStyles({
  pane: {
    width: '340px',
    flexShrink: 0,
    margin: '10px 10px 10px 0',
    boxSizing: 'border-box',
    borderRadius: '12px',
    backgroundColor: vt.pane,
    boxShadow: `0 1px 2px ${vt.paneShadow}, 0 8px 24px ${vt.paneShadow}`,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    fontSize: tokens.fontSizeBase200,
  },
});

/**
 * A second pane to the right of the main one (mockup 05's rule editor). Rendered through a
 * portal so the page keeps owning its state; outside the shell it renders inline.
 */
export function PageAside({ label, children }: { label: string; children: ReactNode }) {
  const s = useStyles();
  const host = useContext(PageAsideHost);
  const pane = (
    <aside className={s.pane} aria-label={label}>
      {children}
    </aside>
  );
  return host ? createPortal(pane, host) : pane;
}
